import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGroupCreate } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSliderGroupCreate = createAsyncThunk(
    'sliderGroupCreate/fetchSliderGroupCreate',
    async ({ file, title, description, content }) => {
        const response = await SliderGroupCreate(file, title, description, content)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const sliderGroupCreateSlice = createSlice({
    name: 'sliderGroupCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGroupCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGroupCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGroupCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGroupCreateSlice.reducer;
